// extracted by mini-css-extract-plugin
export default {"wrapper":"feedback_wrapper__vZfwS","feedback":"feedback_feedback__tm50F"};